import React from 'react'
import Cooperation from './Cooperation'

const index = () => {
  return <Cooperation />
}

export default index
